var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ppcCenter"},[_c('div',{staticClass:"imageInfoTop"},[_c('PPCImageInfo',{attrs:{"id":"imageInfocontainer","accountView":_vm.accountView,"board":_vm.board,"creative":_vm.creative}}),_c('KeyboardNavigation')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }